import  { useEffect } from 'react'

const PageTitle = ({title}) => {
    useEffect (() => {
        document.title = title + " || Milton Hossain";
    },[title])
}

export default PageTitle